import { all, call, put, takeLatest } from 'redux-saga/effects';
import {
	addProductLoanProposalFailure,
	addProductLoanProposalResponseChanged,
	addProductLoanProposalSuccess,
	updateProductLoanProposalFailure,
	updateProductLoanProposalResponseChanged,
	updateProductLoanProposalSuccess,
} from './product-loan-proposal.action';
import { encryptData } from '../../../_common/enode-decode';
import AlertManager from '../../../../utils/alertManager';
import ProductLoanActionTypes from './product-loan-proposal.types';
import { addProductLoanProposal, updateProductLoanProposal } from './product-loan-proposal.service';

/** *********************  START ADD PRODUCT DETAILS  ******************** */
export function* createProductLoanProposal({ payload }: any) {
	try {
		const key = 'AddproductLoanIndexTokenKey';
		const jsonData = {
			DatabaseName: payload.databaseName,
			CompanyID: payload.companyID,
			UserName: payload.userName,
			UserAccessBranchID: payload.userAccessBranchID,
			CreatedBy: payload.userID,
			AreaID: payload.BranchID,
			BranchID: payload.CenterID,
			LoanProposalDate: payload.LoanProposalDate,
			TotalLoanAmount: payload.TotalLoanAmount,
			LoanStartDate: payload.LoanStartDate,
			LoanEndDate: payload.LoanEndDate,
			MeetUpLocation: payload.MeetUpLocation,
			MemberMeetupLat: payload.MemberMeetupLat,
			MemberMeetupLong: payload.MemberMeetupLong,
			MeetUpTime: payload.MeetUpTime,
			GroupID: payload.GroupID,
			GroupProductID: payload.GroupProductID,
			GroupMemberLeadID: payload.GroupMemberLeadID,
			GroupOfficerID: payload.GroupOfficerID,
			CreatedUser: payload.userID,
			LoanIndexGroupMember: payload.groupMemberArr,
			ProductInvestorDetails: payload.ProductInvestorDetails,
			LoanIndexType: payload.LoanIndexType,
			FunderName: payload.FunderName,
			LoanType: payload.LoanType,
			LoanOfficerID: payload.LoanOfficerID,
			memberLeadID: payload.memberLeadID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(addProductLoanProposal, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(addProductLoanProposalFailure(responseData.data));
		} else {
			yield put(addProductLoanProposalSuccess(responseData.data));
		}
	} catch (error) {
		yield put(addProductLoanProposalFailure(error));
	}
}

export function* resetAddProductLoanProposalResponse() {
	yield put(addProductLoanProposalResponseChanged());
}

export function* onCreateProductLoanProposal() {
	yield takeLatest(
		ProductLoanActionTypes.ADD_PRODUCT_LOAN_PROPOSAL_START,
		createProductLoanProposal,
	);
}

export function* onCreateProductLoanProposalResponseReset() {
	yield takeLatest(
		ProductLoanActionTypes.ADD_PRODUCT_LOAN_PROPOSAL_RESPONSE_RESET,
		resetAddProductLoanProposalResponse,
	);
}
/** *********************  END ADD PRODUCT DETAILS ******************** */

/** *********************  START UPDATE PRODUCT DETAILS  ******************** */
export function* updateExistProductLoanProposal({ payload }: any) {
	try {
		const key = 'UpdateproductLoanIndexTokenKey';
		const jsonData = {
			DatabaseName: payload.databaseName,
			CompanyID: payload.companyID,
			UserName: payload.userName,
			UserAccessBranchID: payload.userAccessBranchID,
			CreatedBy: payload.userID,
			AreaID: payload.BranchID,
			BranchID: payload.CenterID,
			LoanProposalDate: payload.LoanProposalDate,
			TotalLoanAmount: payload.TotalLoanAmount,
			LoanStartDate: payload.LoanStartDate,
			LoanEndDate: payload.LoanEndDate,
			MeetUpLocation: payload.MeetUpLocation,
			MemberMeetupLat: payload.MemberMeetupLat,
			MemberMeetupLong: payload.MemberMeetupLong,
			MeetUpTime: payload.MeetUpTime,
			GroupID: payload.GroupID,
			GroupProductID: payload.GroupProductID,
			GroupMemberLeadID: payload.GroupMemberLeadID,
			GroupOfficerID: payload.GroupOfficerID,
			CreatedUser: payload.userID,
			LoanIndexGroupMember: payload.groupMemberArr,
			ProductInvestorDetails: payload.ProductInvestorDetails,
			LoanIndexType: payload.LoanIndexType,
			FunderName: payload.FunderName,
			LoanType: payload.LoanType,
			LoanOfficerID: payload.LoanOfficerID,
			memberLeadID: payload.memberLeadID,
			LoanIndexID: payload.LoanIndexID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(updateProductLoanProposal, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateProductLoanProposalFailure(responseData.data));
		} else {
			yield put(updateProductLoanProposalSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateProductLoanProposalFailure(error));
	}
}

export function* resetUpdateProductLoanProposalResponse() {
	yield put(updateProductLoanProposalResponseChanged());
}

export function* onUpdateProductLoanProposal() {
	yield takeLatest(
		ProductLoanActionTypes.UPDATE_PRODUCT_LOAN_PROPOSAL_START,
		updateExistProductLoanProposal,
	);
}

export function* onUpdateProductLoanProposalResponseReset() {
	yield takeLatest(
		ProductLoanActionTypes.UPDATE_PRODUCT_LOAN_PROPOSAL_RESPONSE_RESET,
		resetUpdateProductLoanProposalResponse,
	);
}
/** *********************  END UPDATE PRODUCT DETAILS ******************** */

export function* productLoanProposalSaga() {
	yield all([
		call(onCreateProductLoanProposal),
		call(onCreateProductLoanProposalResponseReset),
		call(onUpdateProductLoanProposal),
		call(onUpdateProductLoanProposalResponseReset),
	]);
}
